import { useMutation } from '@tanstack/react-query'

import { introspectChallengeSuccessToken } from '@src/api'
import { DefaultApiIntrospectChallengeSuccessTokenRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useIntrospectChallengeSuccessToken = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiIntrospectChallengeSuccessTokenRequest) =>
      introspectChallengeSuccessToken(axiosInstance, params),
  })
}
